import heroImage from '@/assets/images/works/projects/hyperdrive/hyperdrive-logo.png'
import compareLeft from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-left.mp4'
import compareRight from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-right.png'

const framesModules = import.meta.glob(
  '/src/assets/images/works/projects/hyperdrive/hero-frames/*.png',
  { eager: true, import: 'default' }
)
const heroFrames = Object.keys(framesModules)
  .sort()
  .map((path) => framesModules[path])

export default {
  meta: {
    title: 'HYPERDRIVE',
    headline: 'Into the <br> <span class="text-electric-purple">Hyperspace.</span>',
    label: 'Case Study 02',
    description:
      'Um portfólio imersivo com temática Sci-Fi, desenvolvido com Vue 3 e animação de velocidade da luz.',
    chips: [
      { text: 'Portfolio', dotColor: 'bg-electric-purple' },
      { text: 'Creative Dev', dotColor: 'bg-blue-500' },
      { text: '2024' },
    ],
    heroImage: heroImage,
    heroFrames: heroFrames,
  },
  sidebar: {
    title: 'Índice',
    meta: [
      { label: 'Cliente', value: 'Personal Project' },
      { label: 'Tipo', value: 'Web Portfolio' },
      { label: 'Papel', value: 'Creative Developer' },
      { label: 'Stack', value: 'Vue 3, Tailwind CSS, GSAP, Canvas' },
      { label: 'Ano', value: '2024' },
      { label: 'Repo', value: 'Open Source' },
    ],
    cta: 'Ver Site',
    ctaLink: 'https://hyperdrive.juanlias.com',
    repoLink: 'https://github.com/juanlias/hyperdrive-portfolio',
  },
  sections: {
    overview: {
      id: 'overview',
      menuLabel: 'Visão Geral',
      title: 'O Projeto',
      highlight:
        'Hyperdrive redefine a marca pessoal combinando o poder do Vue 3, Tailwind CSS e GSAP em uma interface de ficção científica inspirada em Star Wars.',
      cards: [
        {
          title: 'Hyperspace Intro',
          text: 'Simulação de viagem espacial em Canvas que gera engajamento imediato desde o primeiro segundo.',
        },
        {
          title: 'Comando',
          text: 'Painel de controle retro-futurista com estética Glassmorphism, bordas de neon e feedback háptico visual.',
        },
      ],
    },
    enfoque: {
      id: 'enfoque',
      menuLabel: 'Conceito',
      label: 'Sistema Kyber',
      title: 'Personalização Total',
      description:
        'Inspirado nos sabres de luz, o sistema <strong>Kyber Crystal</strong> permite a troca de paleta de cores em tempo real (Ilum, Adegan, Hurrikaine) através de varreduras holográficas e cascatas de energia.',
      tags: ['Glassmorphism', 'Kyber Crystals', 'Holographic UI'],
    },
    problema: {
      id: 'problema',
      menuLabel: 'Performance',
      title: 'O Desafio',
      description:
        'Criar um fator visual "Uau" sem sacrificar a velocidade de carregamento. Equilibrar uma interface experimental com sistemas complexos de acessibilidade e suporte multilíngue (incluindo Shavian).',
      stats: [
        { value: '5', label: 'Temas' },
        { value: '4', label: 'Idiomas' },
      ],
    },
    transformacion: {
      id: 'antesdespues',
      menuLabel: 'Comparativo',
      title: 'Calibração Visual',
      beforeLabel: 'Sistemas em Espera',
      afterLabel: 'Holographic Mode',
      instruction: 'Arraste para escanear',
      beforeImage: compareLeft,
      afterImage: compareRight,
    },
    tecnologia: {
      id: 'tecnologia',
      menuLabel: 'Stack Tecnológico',
      title: 'Engenharia',
      categories: [
        { name: 'Core', items: ['Vue 3', 'Vite', 'Vue I18n'] },
        { name: 'Animation', items: ['GSAP', 'Canvas API', 'WebGL'] },
        { name: 'Styles', items: ['Tailwind CSS', 'HugeIcons'] },
      ],
    },
    footer: {
      prev: { label: 'Caso Anterior', title: 'FinanzaFlow', link: '/works/finanza' },
      next: null,
    },
  },
}
